var headerHeight = {
  init: function() {
    var h = $(".main-header").height();
    // setHeights
    $("#mh-app-root").css("padding-top", h);
  },
  reinit: function() {
    var mq = window.matchMedia("(max-width: 768px)");
    if (mq.matches) {
      this.init();
      console.log("mobile match");
    } else {
      this.init();
      console.log("desktop match");
    }
  }
};


var app = new Vue({
  el: '#app-root',
  delimiters: ['${', '}'],
  data: {
    boxSize: box_size,
    totalWeight: 10,
    currentWeight: 0,
    weightLeft: 0,
    step: 1,
    totalStep: 4,
    flavor: flavor,
    baseProduct: {},
    basePrice: null,
    products: [],
    flavors: [],
    flavorsBk: [],
    candy: [],
    candyBk: [],
    selectedProduct: null,
    currentProduct: null,
    addedItem: 0,
    totalPrice: 0,
    qty: 1,
    properties: [],
    boxs: [],
    boxsWrapper: {},
    text: '',
    to: '',
    from: '',
    card: '',
    card_blank: false,
    disabled: true,
    maxCharacters: 200,
    greeting: [],
    giftCard: {
      images: [{
        src: '//cdn.shopify.com/s/files/1/0325/8941/4539/files/THANK_YOU_from_the_bottom_of_my_heart_Poster_Landscape_Newsletter_Poster_Landscape_24_x_24_in.png?v=1633641294'
      }]
    },
    emptyItem: {
      id: 0,
      product_id: 0,
      variant_id: 0,
      name: 'EMPTY',
      images: ['//cdn.shopify.com/s/files/1/2081/2117/t/2/assets/no-smoothie-gray.png?7819278544643260185'],
      url: '',
      description: ''
    },
    cart: [],
    cartItem: [],
    items: [],
    filterCart: [],
    modal: false,
    checkoutmodal: false,
    product: {},
    variant: null,
    active: 0,
    input: 0,
    currentImage: null,
    productmodal: false,
    modalModify: false,
    cartModify: false,
    cartnote: cartTextNote,
    showLoader: false,
    search: '',
    selected: 'all',
    isMouseEnter: false,
  },
  mounted: function() {
    $.getJSON('/collections/all/products.json?limit=0', function(data) {

      var productData = data.products;
      console.log("----PRODUCTS ------ new 2");
      console.log(data.products.length);

      app.products = productData;

    }).done(function() {
      // for (var i = 0; i < app.boxSize; i++) {
      //   app.boxs.push(app.emptyItem)
      // }

      var json = JSON.parse($("#mh-json").html());
      app.baseProduct = json;
      app.basePrice = app.totalPrice = json ? json.price / 100 : 0;

      // app.flavors = app.products.filter(product => product.tags.includes(app.flavor));
      app.flavors = app.products;
    });


    Shopify.theme.cart.getState().then(state => {
      //console.log(state);
      app.cart = state;
      app.items = state.items.filter(item => !item.properties.handle);
      // console.log(app.items);
    });
  },
  watch: {
    boxSize: function(val) {
      console.log("new val: " + val);
      app.boxSize = box_size;

      console.log("reset value: ", val, box_size, app.boxSize);
    },
    boxs: function(product) {
      app.totalPrice = app.formatMoney(app.boxs.reduce((init, product) => init += product.price * product.qty * 100, 0)); 
      console.log(app.totalPrice);
    },
    card_blank: function() {
      this.disabled = !this.card_blank;
    },
    text: function() {
      console.log(this.text);
      if (this.text.length) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    step: function () {
      app.search = null;
      app.selected = 'all';
    }
  },
  filters: {
    capitalize: function(value) {
      if (!value) return ''
      value = value.toString()
      return value.toUpperCase();
    }
  },

  computed: {
    getCandy: function() {
      if (app.search) {
        return app.candy.filter(product => product.title.toLowerCase().indexOf(app.search) != -1);
      } else {
        return app.candy;
      }
    },
    getFlavors: function() {
      if (app.search) {
        return app.flavors.filter(product => product.title.toLowerCase().indexOf(app.search) != -1);
      } else {
        return app.flavors;
      }
    },
    tags: function () {
      if (app.step == 2) {
        return [... new Set(app.flavorsBk.map(product => product.tags).flat())];
      } else {
        return [... new Set(app.candyBk.map(product => product.tags).flat())];
      }
    },
    charactersRemaining: function() {
      return this.maxCharacters - this.text.length;
    },
    charactersOver: function() {
      return this.isOver() ? this.text.length - this.maxCharacters : 0;
    },
    totalUpdatedPrice: function() {
      return app.totalPrice = app.formatMoney(app.boxs.reduce((init, product) => init += product.price * product.qty * 100, 0)); 
    },
    totalWeightLeft: function() {
      return Math.ceil(
        Math.abs(
          ((this.totalWeight - this.currentWeight) / this.totalWeight) * 100 - 100
        )
      );
    },
    totalWeightLeftText: function() {
      var complete;
      var done = Math.ceil(
        Math.abs(
          ((this.totalWeight - this.currentWeight) / this.totalWeight) * 100 - 100
        )
      );
      if (done <= 45) {
        return "Total Weight: Start shopping!"
      } else if( done <= 50){
        return  "Total Weight: Halfway full!";
      } else if( done <= 75){
        return  "Total Weight: Still got space!.";
      } else if( done <= 95){
        return  "Total Weight: Almost full!";
      } else if( done <= 100){
        return  "Total Weight: Full!";
      }
    },


    weightStyles: function() {
      return {
        width: this.currentWeight > this.totalWeight ? 100 : this.totalWeightLeft + '%'
      };
    }
  },
  methods: {
    buildbox: function(product, index, variant) {
      console.log('product: ', product);
      console.log('index: ', index);
      console.log('variant: ', variant);
      // if (app.addedItem >= app.boxSize) return false;
      var grams = Math.ceil(variant.grams * 0.0022046);
      app.currentWeight += grams;
      // console.log(Math.ceil(variant.grams * 0.0022046));
      if (this.currentWeight <= this.totalWeight) {
        app.addedItem += 1;
        app.selectedProduct = product.title;
        var qty = 1;
        console.log('test');
        console.log(variant.id);
        console.log(app.boxs);
        var idx = _.findIndex(app.boxs, { 'vid': variant.id });
        console.log(idx);
        if (idx !== -1) {
          app.boxs[idx].qty +=  1;
          app.input =   app.boxs[idx].qty;
          // app.boxs[idx].weight +=  app.boxs[idx].weight;
        } else {
          app.boxs.push({
            id: variant.id,
            vid: variant.id,
            title: variant.title.includes("Default Title") ? product.title : product.title + ' - ' + variant.title,
            image: variant.featured_image || product.images[0].src,
            qty: qty,
            weight: grams,
            price: variant.price
          });
          app.input = qty;
        }

        $("#alert").fadeIn('slow').delay(300).fadeOut('fast');
      } else {
          app.currentWeight -= grams;
        alert("Sorry, over weight added !")
      }

    },
    remove: function(variant, index) {
       console.log('variant: ', variant);
      app.addedItem -= 1;
      var grams = variant.weight ? variant.weight :  Math.ceil(variant.grams * 0.0022046);;
      console.log(grams);
      if (grams) {
        app.currentWeight -= grams;
      }
      var idx = _.findIndex(app.boxs, { 'vid': variant.id });
      if (idx !== -1) {
        app.boxs[idx].qty -=  1;
        app.input =   app.boxs[idx].qty;
        console.log("current qty: " +   app.boxs[idx].qty);
        // app.boxs[idx].weight -=  app.boxs[idx].weight;

        if (app.boxs[idx].qty === 0) {
          app.boxs.splice(idx, 1);
        }
      }

    },
    onAddToCart: function (index) {
      app.buildbox(app.currentProduct, index, app.variant );
    },
    onChangeVariant: function (variant = {},index) {
      app.input = 0;

      if (variant) {
        app.variant = variant;
        app.active = index;
        var idx = _.findIndex(app.boxs, { 'vid': variant.id });
        if (idx !== -1) {
          app.input = app.boxs[idx].qty;
          // app.boxs[idx].weight +=  app.boxs[idx].weight;
        }
      }
    },
    onHover: function (product) {
      if (!app.isMouseEnter) {
        // console.log("hover fired");
        app.currentProduct=product;
        app.variant = product.variants[0]
        app.isMouseEnter = true;
        app.onChangeVariant( product.variants[0] ,0 )
      }
    },
    onHoverOut: function (product) {
      // console.log("hover out fired");
      // app.currentProduct=product;
      // app.vid=null
      app.isMouseEnter = false;
      app.input = 0;
    },
    openProduct: function (product) {
      app.productmodal=true;
      app.product=product;
      app.currentImage = product.images[0].src;
      app.onChangeVariant(app.variant,0);
    },
    changeImage: function (image) {
      app.currentImage=image.src;
    },
    addGreeting: function(product, index) {
      app.giftCard = product;
      app.selectedProduct = product.title;
      $("#alert").fadeIn('slow').delay(300).fadeOut('fast', function() {
        app.modal = true;
      });
    },

    updateStepAndScroll: function(step) {
      app.step = step;
      // $("html,body").animate({ scrollTop: 0 }, 400);
    },
    onChangeStep: function(event) {
      var tag = event.target.value;
      app.search = null;
      console.log(event.target.value);
      if (tag == "all") {
        app.flavors = app.flavorsBk;
        app.candy = app.candyBk;
      }else{
        if (app.step == 2) {
          app.flavors = app.flavorsBk.filter( product => product.tags.includes(tag))
        } else {
          app.candy = app.candyBk.filter( product => product.tags.includes(tag))
        }
      }

      // $("html,body").animate({ scrollTop: 0 }, 400);
    },
    increment: function (input) {
      app.buildbox(app.currentProduct, input, app.variant);
    },
    decrement: function (input) {
      app.remove(app.variant, input)
    },
    changeStep: function(step, title, image, collection, collection2, product = null) {
      app.step = step;
      app.boxsWrapper = {
        title: title,
        image: image,
        collection: collection
      };
      console.log("product " + product);
      if (product) {
        $.getJSON('/products/' + product, function (data) {
          var product = data.product;
          app.buildbox(product,0, product.variants[0]);
        });
      }
      if (collection) {
        $.getJSON('/collections/' + collection + '/products.json?limit=' + pageLimit, function(data) {

          var productData = data.products;
          console.log("----PRODUCTS ------ new " + collection);
          console.log(data.products.length);

          app.products = productData;

        }).done(function() {
          var json = JSON.parse($("#mh-json").html());
          app.baseProduct = json;
          app.basePrice = app.totalPrice = json ? json.price / 100 : 0;
          app.flavors = app.products;
          app.flavorsBk = app.products;
        });

      }


      if (collection2) {
        $.getJSON('/collections/' + collection2 + '/products.json?limit=' + pageLimit, function(data) {

          var productData = data.products;
          console.log("----PRODUCTS ------ new " + collection2);
          console.log(data.products.length);

          app.candy = productData;
          app.candyBk = productData;

        })
      }

    },
    checkout: function(step) {
      console.log("remodal close: ", step);
      app.step = step;
      app.modal = false

    },
    openModal: function(step) {
      app.step = step;
      app.modal = true;
    },
    closeModal: function(step) {
      app.step = step || app.step;
      app.modal = false
    },
    isOver: function() {
      return this.charactersRemaining < 0;
    },
    getMediumImg: function(img) {
      // var ext = img.split(".").pop();
      // return img.replace("." + ext, "_medium." + ext);
      return img;
    },
    addToCart: function() {
      console.log('add to cart');
      app.showLoader = true;

      $(".ajax-animate").fadeToggle('fast', function() {
        //Stuff to do *after* the animation takes place
      })
      Shopify.queue = [];
      // Shopify.queue.push({
      //   variantId: app.giftCard.variants[0].id,
      //   quantity: app.qty
      // });
      app.boxs.forEach(function(product, index) {
        if (product.id) {
          Shopify.queue.push({
            variantId: product.id,
            quantity: product.qty
          });
        }
      });
      // add item function
      Shopify.addItem = function(vid, qty, callback, properties, checkout = false) {
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          dataType: "json",
          data: {
            quantity: qty,
            id: vid,
            properties: properties
          },
          success: function(res) {
            console.log("cart added!");

            callback();
          },
          error: function() {
            // if it's not last one Move Along else update the cart number with the current quantity
            if (Shopify.queue.length) {
              Shopify.moveAlong();
            } else {
              window.location.href = "/cart";
              $("#cart-number").replaceWith(
                "<a href='/cart' id='cart-number'>View cart ('" +
                quantity +
                "')</a>"
              );
            }
          },
        });
      };
      // add item
      Shopify.moveAlong = function(first = false) {
        // If we still have requests in the queue, let's process the next one.
        if (Shopify.queue.length) {
          var request = Shopify.queue.shift();
          console.log(request);
          if (first && app.text) {
            Shopify.addItem(
              request.variantId,
              request.quantity,
              Shopify.moveAlong, {
                "Gift Message": app.text,
                "From": app.from,
                "To": app.to,
                "Card": app.card,
                "Empty Card": app.card_blank
              },
              false
            );
          } else {
            Shopify.addItem(
              request.variantId,
              request.quantity,
              Shopify.moveAlong,
              '',
              false
            );
          }
        }
        // If the queue is empty, we will redirect to the cart page.
        else {
          // goto cart pages after queue complete
          var attributes = {
            attributes: {
              'Container': app.boxsWrapper.title,
              'To': app.to,
              'From': app.from,
              'Card': app.card,
              'Gift Message': app.text,
              'From': app.from,
              'To': app.to,
              'Card': app.card,
              'Empty Card': app.card_blank,
              'Special Instructions': app.cartnote
            }
          };
          var params = {
            type: 'POST',
            url: '/cart/update.js',
            data: attributes,
            dataType: 'json',
            success: function(data) {
              window.location.href = "/checkout";
              // window.location.href = "/cart";

              console.log(data);
            },
            error: function(XMLHttpRequest, textStatus) {
              console.log("error");
            }
          }
          jQuery.ajax(params);
          //   $.post('/cart/update.js', attributes).done(function(res){
          //    console.log(res)
          //    window.location.href = "/cart";
          // });

        }
      };
      console.log("flavors will add first");
      Shopify.moveAlong(true);

    },
    cartRemove: function(key, id, handle, group) {
      console.log(key, id, handle, group);
      $("body").toggleClass('delete-cart');
      $(".cart-loader").toggleClass('hide');
      Shopify.theme.cart.removeItem(key).then(state => {
        console.log(`There is now ${state.items.length} item(s) in your cart`);
        return {
          state,
          handle: handle,
          group: group
        };
      }).then(function(obj) {
        console.log(obj.state, obj.handle, obj.group);
        var filterKey = obj.state.items.filter(item => item.properties.group == obj.group);
        /*callback function for find the group*/
        var moveAlong = function() {
          if (filterKey.length) {
            var request = filterKey.shift();
            console.log(request);
            Shopify.theme.cart.removeItem(request.key).then(state => {
                console.log(`There is now ${state.items.length} item(s) in your cart`);
              })
              .then(function() {
                moveAlong();
              });

          } else {
            // If the queue is empty, we will redirect to the cart page.
            document.location.href = '/cart';
          }
        };
        moveAlong();
      });
    },
    // formatMoney
    formatMoney: function(price, qty = 1, rate = 1, currency = '') {
      return Shopify.formatMoney(price * rate * qty) + ' ' + currency;
    }
  }
});


var clearCart = {
  init: function() {
    $(".btn-remove").on('click', function(event) {
      event.preventDefault();
      Shopify.theme.cart.clearItems().then(state => {
        console.log("cart is empty");
        console.log(state);
        window.location = "/collections";
      });
    });
  }
};

var fetchCart = function() {
  Shopify.theme.cart.getState().then(state => {
    // console.log(state);
    const items = state.items.filter(item => item.properties.handle == "doughee-build-a-box-12");
    console.log(items);
  });
};
/*product pages*/
var qty = {
  init: function () {
    $(".number").on("click", "span", function (event) {
      var self = $(this),
        input = self.siblings("input"),
        qty = parseInt(input.val(), 10);
      if (event.target.className === "plus") {
        // input.val(qty + 1);
        app.input = qty + 1;
      } else {
        if (qty > 0) {
          // input.val(qty - 1);
          app.input = qty - 1;
        }
      }
    });
  },
  unload: function () {
    $(".number").off("click");
  },
};
$(function() {
  clearCart.init();
  // qty.init();
  console.log(flavor);
})


$(document).ready(function() {
  $('.swatch .swatch-element').each(function() {               
    $(this).attr('tabindex', '0');
});
  
  
  var checkValue = $('.swatch input[type="radio"]:checked').attr('value');
  $('span.swatch_value').html(checkValue);
  $('.swatch input').click(function() {
    var SwatchValue = $(this).attr('value');
    $('span.swatch_value').html(SwatchValue);
  });
});

